export const decodeJWT = <T>(token: Readonly<string>) => {
  try {
    const [, payload] = token.split('.');

    const base64 = payload
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .padEnd(Math.ceil(payload.length / 4) * 4, '=');

    const binaryString = atob(base64);
    const bytes = Uint8Array.from(binaryString, (char) => char.charCodeAt(0));
    const decoded = new TextDecoder().decode(bytes);

    return JSON.parse(decoded) as T;
  } catch {
    return null;
  }
};
